import './styles.scss'
import React, { useRef, useState, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import XLSX from 'xlsx'
import { FormGroup, Button, Input, Modal } from 'reactstrap'
import SheetJSFT from './types'
import { setExcelData } from '../../redux/actions/marketing'
import { I18n } from 'react-redux-i18n'
import { Button as FormButton } from 'components/Form'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'

/**
 * Get excell range
 * @param {string} range
 * @param {[string]} cells
 *
 * @returns {string}
 */
const getRange = (range, cells) => {
  const [first, last] = range.split(':')

  let row = Number(last.replace(/[A-Za-z]/ig, ''))
  if (row > 500000) {
    row = Math.max(...cells.join().replace(/[A-Za-z]/ig, '').split(',').map(Number))
  }

  let col = last.replace(/\d/ig, '')
  if (col.length > 1) {
    let max = 0

    cells
      .join()
      .replace(/\d/ig, '')
      .split(',')
      .forEach(elem => {
        const size = elem.split('').reduce((preV, next) => preV += next.charCodeAt(), 0)

        if (size > max) {
          max = size
          col = elem
        }
      })
  }

  return `${first}:${col}${row}`
}

/**
 * Check for some headers empty
 * @param {[Object]} data
 */
const isEmptySomeHeader = (data) => {
  return data.findIndex(elem => ![undefined, null, ''].includes(elem.__EMPTY)) !== -1
}

/**
 * Excel Reader
 */
const ExcelReader = () => {
  const dispatch = useDispatch()
  const hiddenFileInput = useRef(null)

  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if (error) {
      setShowModal((show) => !show)
    }
  }, [error])

  const onToggleModal = () => setShowModal((currentModal) => !currentModal)

  const handleChange = useCallback(({ target: { files = [] } }) => {
    setError('')

    const file = files.length ? files[0] : null

    if(!file) {
      setError('error-excel-bad-file-selected')
      return
    }

    const reader = new FileReader()
    const rABS = !!reader.readAsBinaryString

    reader.onload = ({ target: { result } }) => {
      setLoading(true)

      try {
        if (!result) throw ({ type: 'error-excel-bad-file-selected' })

        /* Parse data */
        const data = result
        const wb = XLSX.read(
          data,
          { type: rABS ? 'binary' : 'array', sheets: 0 }
        )

        const sheetName = wb.SheetNames[0]
        const sheet = wb.Sheets[sheetName]
        const range = getRange(sheet['!ref'], Object.keys(sheet).filter(d => !d.includes('!')))

        const sheetData = XLSX.utils.sheet_to_json(
          sheet,
          { raw: true, blankrows: false, range }
        )

        if (!sheetData.length) throw ({ type: 'error-excel-upload-file-empty' })

        // Check for empty header
        if (isEmptySomeHeader(sheetData)) throw ({ type: 'error-excel-some-header-empty' })

        const rows = sheetData.length

        dispatch(setExcelData({
          rows,
          excelSheets: [{
            headers: Object.keys(sheetData[0]),
            data: sheetData,
            sheetName,
            file: file.name,
            num_rows: rows,
          }]
        }))
      } catch(error) {
        setError(error.type || 'error-excel-bad-file-selected')

        hiddenFileInput.current.value = null
        setLoading(false)
      }
    }

    rABS ? reader.readAsBinaryString(file) : reader.readAsArrayBuffer(file)
  }, [dispatch])

  return (
    <div>
      <FormGroup>
        {
          loading
            ? <Nixi1Spinner width='20px' height='20px' />
            : (
              <Button
                color='primary'
                onClick={() => hiddenFileInput.current.click()}
                className='new-button icon'
              >
                <i className='fa fa-upload'></i>
                <span>{I18n.t('dashboard_add-file')}</span>
              </Button>
            )
        }
        <Input
          color='primary'
          type='file'
          name='file'
          id='excel-file'
          accept={SheetJSFT}
          onChange={handleChange}
          style={{ display: 'none' }}
          innerRef={hiddenFileInput}
          invalid={!!error}
        />
        {/* <FormFeedback className='mt-2'>{I18n.t(error)}</FormFeedback> */}
      </FormGroup>

      <Modal isOpen={showModal} toggle={onToggleModal} centered contentClassName='modal-content-excel-error' className='modal-excel-error'>
        <div className='modal-wrapper-header'>
          <h1>{I18n.t('excel_error')}</h1>
          <span onClick={onToggleModal}>
            <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close'/>
          </span>
        </div>
        <div className='modal-wrapper-body'>
          <p>{I18n.t('excel_error_message')}</p>
          <div className='wrapper-image-excel'>
            <span>{I18n.t('dashboard_example')}</span>
            <img src='img/excel-ejemplo_2x.png' alt='ejemplo'/>
          </div>
        </div>
        <div className='wrapper-buttons'>
          <FormButton
            secondary={true}
            value={I18n.t('dashboard_understand')}
            onClick={onToggleModal}
          />
        </div>
      </Modal>
    </div>
  )
}

export default ExcelReader
